const PARAMS_SEPARATOR = " ";

/**
 * Parameters of an indicator as PO shows them after its name: the input
 * values in the order of the settings modal, e.g. "5 1" for Bollinger Bands.
 *
 * @param {object} inputs - { [input key]: value } of engine.getIndicators()
 * @returns {string}
 */
export const formatIndicatorParams = (inputs) => Object.values(inputs).join(PARAMS_SEPARATOR);

/**
 * "Name parameters", e.g. "RSI 14" — the Current tab, the legend and the pane headers.
 *
 * @param {{ name: string, inputs: object }} indicator - engine.getIndicators() item
 * @returns {string}
 */
export const formatIndicatorLabel = ({ name, inputs }) => {
  const params = formatIndicatorParams(inputs);

  return params ? `${name}${PARAMS_SEPARATOR}${params}` : name;
};
